export default "__VITE_ASSET__BQupp4qj__"